<template>
  <div class='page-watch'>
    <div class="video-container" id="video-container-0"></div>
    <div class="video-container" id="video-container-1"></div>
    <div class="video-container" id="video-container-2"></div>

    <div class="video-container" id="video-container-3"></div>
    <div class="video-container" id="video-container-4"></div>
    <div class="video-container" id="video-container-5"></div>

    <div class="video-container" id="video-container-6"></div>
    <div class="video-container" id="video-container-7"></div>
    <div class="video-container" id="video-container-8"></div>
<!--    <button @click='full'>full</button>-->
  </div>
</template>

<script>

export default {
  data() {
    return {
      videoList: [
        'https://yunxi-material-library-prod.oss-cn-hangzhou.aliyuncs.com/recordVideo/49773/iBhn4nkk2En8irYdec8TNZE8bJ6BapEK.mp4',
        'https://yunxi-material-library-prod.oss-cn-hangzhou.aliyuncs.com/recordVideo/49773/NtJdhMDX6pGdYFyehsEji72fGRD2HNQe.mp4',
        'https://yunxi-material-library-prod.oss-cn-hangzhou.aliyuncs.com/recordVideo/49773/jP4cdn46d6DsEpp5CxFTDdMzzSxFfdXi.mp4',
        'https://yunxi-material-library-prod.oss-cn-hangzhou.aliyuncs.com/recordVideo/49773/EnfZwtGtz5aHMj7AHT3WPzC48eBiJjrc.mp4',
        'https://yunxi-material-library-prod.oss-cn-hangzhou.aliyuncs.com/recordVideo/49773/QPTjS6ArYPem2AA4PGfBAQFEfWwAdwid.mp4',
        'https://yunxi-material-library-prod.oss-cn-hangzhou.aliyuncs.com/recordVideo/49773/MMS4XG6hrGrkpHjYJjZAyzXkMc7mfiST.mp4',
        'https://yunxi-material-library-prod.oss-cn-hangzhou.aliyuncs.com/recordVideo/49773/nhNAM5WyBbjkh78Jyz6yjAsEtQyPBYt3.mp4',
        'https://yunxi-material-library-prod.oss-cn-hangzhou.aliyuncs.com/recordVideo/49773/fAhKCzhzECnDR2FzHzcS7KhyYGxnnDxZ.mp4',
        'https://yunxi-material-library-prod.oss-cn-hangzhou.aliyuncs.com/recordVideo/49773/5eZYRstdHPzHRR3jcxtm2mHaj2Y2EMFc.mp4'
      ],
    }
  },
  mounted() {
    this.startPlay()
    document.addEventListener('keydown', (e) => {
      if (e.keyCode === 13) {
        this.toggleFullScreen()
      }
    }, false)
  },
  methods: {
    startPlay() {
      for (let i = 0; i < 9; i++) {
        this.initTcPlayer(`video-container-${i}`, this.videoList[i])
      }
    },

    initTcPlayer(container, playUrl) {
      this.player = new window.TcPlayer(container, {
        mp4: playUrl,
        autoplay: true,
        live: false,
        loop: true,
        volume: 0,
        controls: 'none',
        fullscreen: false,
        width: '500px',
      })
    },

    toggleFullScreen() {
      if (!document.fullscreenElement) {
        document.documentElement.requestFullscreen()
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen()
        }
      }
    },

    initRandom(min, max) {
      return Math.floor(Math.random() * (max - min)) + min
    },
  },
}
</script>

<style lang='scss' scoped>
.page-watch {
  position: absolute;
  top: 0;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 20px;
  height: 100vh;
  z-index: 999;
  width: 100vw;
  box-sizing: border-box;
  background: #000;
  padding-left: 50px;
  .video-container {
    width: 100%;
    max-width: 33.3vw;
    height: 300px;
  }
}
</style>
